import { Team } from '@driftt/api-types'

import { CustomerAPI } from 'api'

export const getTeams = () => CustomerAPI.get<Team>(`/teams`)
export const setGate = (orgId: number, gate: string, value: string) =>
  CustomerAPI.patch(`/gates/organizations/${orgId}`, [
    {
      operation: 'set',
      property: gate,
      value: value,
    },
  ])
